const IconSelectButton = ({ isSelected, icon, label, onClick, className }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${isSelected ? 'border-primary-700 text-primary-700' : 'border-gray-200 text-gray-500'} p-2 border rounded-md ${className}`}
        >
            {icon}
            {!!label && <div className="mt-2 text-sm leading-[1.2]">{label}</div>}
        </button>
    );
};

export default IconSelectButton;
